import { SnackbarState } from 'ia-react-core/~/interfaces/SnackbarState';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import NotifySnackbarById from 'ia-react-core/~/actions/snackbar/NotifySnackbarById';
import DismissSnackbarById from 'ia-react-core/~/actions/snackbar/DismissSnackbarById';
import NotifySnackbarByName from 'ia-react-core/~/actions/snackbar/NotifySnackbarByName';
import DismissSnackbarByName from 'ia-react-core/~/actions/snackbar/DismissSnackbarByName';
import notifySnackbarById from '../../../actions/snackbar-fn/notifySnackbarById';
import dismissSnackbarById from '../../../actions/snackbar-fn/dismissSnackbarById';
import notifySnackbarByName from '../../../actions/snackbar-fn/notifySnackbarByName';
import dismissSnackbarByName from '../../../actions/snackbar-fn/dismissSnackbarByName';

export default function snackbarReducer(state: SnackbarState, action: CoreAction) {
  const snackbarId = state?.snackbarId;
  const name = state?.name;

  switch (action.type) {
    case `${notifySnackbarById.type}/${snackbarId}`:
      return reduceOpenSnackbar(state, action as NotifySnackbarById);
    case `${dismissSnackbarById.type}/${snackbarId}`:
      return reduceDismissSnackbar(state, action as DismissSnackbarById);
    case `${notifySnackbarByName.type}/${name}`:
      return reduceOpenSnackbar(state, action as NotifySnackbarByName);
    case `${dismissSnackbarByName.type}/${name}`:
      return reduceDismissSnackbar(state, action as DismissSnackbarByName);
    default:
      return state;
  }
}

function reduceOpenSnackbar(state: SnackbarState, { message, notificationId, options }: NotifySnackbarById | NotifySnackbarByName): SnackbarState {
  return {
    ...state,
    notifications: [...state.notifications, { message, notificationId, options }],
  };
}

function reduceDismissSnackbar(state: SnackbarState, { notificationId }: DismissSnackbarById | DismissSnackbarByName): SnackbarState {
  if (notificationId) {
    return {
      ...state,
      notifications: state.notifications.filter((notification) => (
        notification.notificationId !== notificationId
      )),
    };
  }

  return {
    ...state,
    notifications: [],
  };
}
